import { clsx } from 'clsx'
import { useState } from 'react'
import { useEffect, useRef } from 'react'

type Props = {
  library: Library
  id: string
  setName: (name: string) => void
  setId: (id: string) => void
  setImageCount: (imageCount: number) => void
}

export default function LibraryItem({ library, id, setName, setId, setImageCount }: Props) {
  const textRef = useRef<HTMLSpanElement>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(textRef.current.offsetWidth < textRef.current.scrollWidth)
    }
  }, [library.name])

  const handleClick = () => {
    // Set the library data
    setName(library?.name ?? '')
    setId(library?.id ?? '')
    setImageCount(library?.imagesCount ?? 0)

    // Smooth scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <button
      type="button"
      className={clsx(
        'relative w-full h-10 bg-gray-100 rounded-md flex items-center justify-center text-gray-700 px-2',
        'overflow-visible whitespace-nowrap group',
        library.id && library.id === id && 'border-[1px] border-red-500',
      )}
      onClick={handleClick}
    >
      {isOverflowing && (
        <span
          className={clsx(
            'absolute left-1/2 -translate-x-1/2 bottom-full mb-2',
            'px-2 py-1 bg-gray-800 text-white rounded-md text-sm',
            'opacity-0 group-hover:opacity-100 transition-opacity duration-200',
            'pointer-events-none whitespace-nowrap',
          )}
        >
          {library?.name}
        </span>
      )}
      <span ref={textRef} className="overflow-hidden text-ellipsis">
        {library?.name}
      </span>
    </button>
  )
}
